import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-user-groups',
    imports: [
        RouterModule
    ],
    template: `<router-outlet />`,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class UserGroupsComponent {

}
